const main = {
  'App support link':
    'https://support.shoplineapp.com/hc/zh-tw/articles/23966890906649',
  'Config GMC': 'Google Merchant Center - 購物廣告設定',
  'Config GMC Caption':
    '透過 Content API 串接能自動上傳你的商品資料到 Google Merchant Center，可以在 Google 廣告及其他 Google 服務中使用。請連結 Google Merchant Center 的子帳戶。',
  'Merchant Center ID': 'Google Merchant ID',
  'Merchant Center ID - description_unintegrated':
    '你的網店尚未與任何 Google Merchant Center 帳戶串接並完成驗證，請前往 基本資料 > 第三方網域工具 > Google Merchant Center 串連',
  'Merchant Center ID - description_integrated':
    '啟用 Content API 後，將會傳送產品資料至以下驗證完成的 Google Merchant Center 帳戶。',
  'Merchant Center ID - action button_unintegrated': '前往串接',
  'Merchant Center ID - action button_integrated': '查看設定',
  'Preorder Period': '出貨遞延天數',
  'Merchant has been saved successfully': '商家設定已成功保存',
  'Failed to save merchant': '商家設定保存失敗',
  'Failed to connect with MCA merchant':
    '串接失敗，請勿使用 MCA (multi-client account) 帳號進行串接',
  'Failed to connect with invalid domain':
    '串接失敗，請確認你的 Google Merchant Center 帳號已完成網域驗證',
  'Successfully set the Region and Language for Ads Delivery':
    '成功設定廣告投放地區及語系',
  'Please enter numbers only': '請輸入有效的 GMC ID',
  'The shipping delay days cannot be left blank or set to fewer than 30.':
    '出貨遞延天數不可留空或小於 30',
  'Upload products to GMC': '上傳商品至 GMC 功能',
  'Upload products to GMC - description':
    '請務必將以下連結複製並加入 Google Merchant Center，方能成功使用 Content API 即時上傳商品至 GMC 功能',
  'Upload products to GMC - step 1': '1. 點擊右邊 icon 複製 Email',
  'Upload products to GMC - step 2':
    '2. 進入 Google Merchant Center > 工具與設定（右上角偏中間齒輪 icon 點入） > 帳戶存取權 > 使用者',
  'Upload products to GMC - step 3': '3. 新增使用者並 Share 管理員權限至使用者',
  'Save before leaving': '請注意，在離開此頁之前，請先儲存內容。',
  'Authorize Content API Title': '授權 Content API 服務帳戶使用權限',
  'Authorize Content API Description':
    '請依照 <1>FAQ</1> 指示，前往 Google Merchant Center 後台下載 Content API 服務帳號憑證，並將憑證檔案上傳於此',
  'Content API FAQ Link':
    'https://support.shoplineapp.com/hc/zh-tw/articles/23966890906649',
  'Upload Files Here': '上傳檔案',
  'Invalid Credential File': '檔案無效，請檢查或更新你的憑證檔案',

  'Config region & locale': '投放地區及語系設定',
  'Config region & locale Caption':
    '連接 Google Merchant Center 後，可以在此管理及無時無刻自動更新產品動態饋給。Google Merchant Center 會根據你設定的投放地區及語系將你的商品廣告展示出去。',
  'Config region & locale Alert':
    '請注意，商品需填寫符合投放語系的標題、摘要及描述才能成功上傳。',
  'Signed in with Google': '已登入 Google 授權',
  "You're signed in with Google": '成功登入 Google 授權',
  'Automatically connect Merchant API — no manual setup required':
    '自動串接 Merchant API，無需手動設定',
  'Go to Google Merchant Center': '前往 Google Merchant Center 後台',
  'Sign in with your Google account': '請登入 Google 授權',
  'Sign in with Google': '登入 Google 授權',
  'Learn more': '了解更多',
  'Connect a new Google Merchant Center account?':
    '綁定新建立的 Google Merchant Center 帳號？',
  'When your store is connected to a Google Merchant Center account, disconnecting it will have the following effects:':
    '當商店已串接 Google Merchant Center 帳號時，解除串接將產生以下影響：',
  'Website ownership will be transferred to the new GMC account.':
    '網站擁有權將轉移至新的 GMC 帳號',
  'Product data will be synced to the new GMC account.':
    '商品資料將同步至新的 GMC 帳號',
  'Products in the original GMC account will be marked as "Disapproved".':
    '原 GMC 帳號中的商品將被標示為「未核准」',
  'Ad campaigns linked to the original GMC account will be interrupted.':
    '原 GMC 帳號所連結的廣告投放將會中斷',
  'The original GMC account will be deactivated and can no longer be used.':
    '原 GMC 帳號將被關閉，無法再使用',
  'A GMC sub-account has been created in your SHOPLINE MCA':
    '您在 SHOPLINE MCA 的 GMC 子帳號已建立',
  'Create and connect Google Merchant Center account':
    '建立與串接 Google Merchant Center 帳號',
  'We will help you create a new GMC account using your authorized Google account and automatically connect it to SHOPLINE.':
    '我們會協助您使用授權的 Google 帳號建立 Google Merchant Center 帳號，並自動完成與 SHOPLINE 的串接。',
  'Connect now': '一鍵串接',
  'A new Merchant Center account has been created and connected to your store. Please check your inbox and accept the Google Merchant Center admin invitation.':
    '已為您建立新的 Merchant Center 帳號並完成串接，請至您的信箱收信，並接受 Google Merchant Center 管理邀請。',
  'Website ownership has been transferred to this account.':
    '網站擁有權已轉移至此帳號',
  'Product data will be synced to this account.': '商品資料將同步至此帳號',
  'Connected Merchant Center ID': '已串接 Merchant Center ID',
  Disconnect: '解除串接',
  'Disconnect Google Merchant Center account?':
    '解除 Google Merchant Center 帳號？',
  'Confirm Disconnect': '確認解除',
  'Product data will stop syncing, and any ads linked to this account will be paused. Are you sure you want to disconnect from Google Merchant Center?':
    '商品資料將停止同步，且與此帳號連結的廣告投放將會中斷。請確認是否要解除與 Google Merchant Center 的串接？',
  'Let Google Merchant Center determine the shipping date for pre-order products.':
    '讓 Google Merchant Center 判斷預購商品的出貨日期',
  'Connect Merchant API': 'Merchant API 串接設定',
  'Through a Merchant API connection, your product data will be automatically uploaded to Google Merchant Center, allowing them to be accessible in Google Ads, YouTube Live Shopping, and other Google features.':
    '透過串接 Merchant API ，商品資料能夠即時自動更新至 Google Merchant Center，並能應用於 Google 廣告、YouTube Live Shopping 購物功能及其他 Google 服務。',
  'Connect Merchant API Label': '串接 Merchant API',
  Recommended: '最佳選擇',
  'Recommended for real-time product sync, hidden product setting, and simplified maintenance.':
    '建議使用： 支援商品資料即時同步與隱藏商品設定，簡化維護流程',
  'Do not connect Merchant API': '不串接 Merchant API',
  'Product data will not sync automatically. You must manually update the Product Feed in Google Merchant Center. This may affect product approval and exposure.':
    '商品資料無法即時同步，需自行前往 Google Merchant Center 更新 Product Feed，可能影響商品上架狀態與曝光',
  'Saved successfully': '儲存成功',
  'Setup incomplete': '設定尚未完成',
  'Placement area and placement language are not configured':
    '尚未設定投放地區及語系',
  'Merchant API settings not saved': '尚未儲存 Merchant API 設定',
  'The system will temporarily save your settings as "Not connected to Merchant API".':
    '系統將自動為您暫時儲存為不串接 Merchant API',
  'Apps Store': '擴充功能商店',
  'My Apps': '我的擴充功能',
  'If you need to manage the Google Merchant Center account, please contact the account owner and request manual authorization in the Google Merchant Center dashboard.':
    '若您需要管理 Google Merchant Center 帳號，請聯繫建立該帳號的管理員，並於 Google Merchant Center 後台手動授權您的帳號',
  'Are you sure you want to cancel?': '確認取消變更',
  'Any unsaved changes will be lost.': '編輯內容將不會保留，是否確認取消變更',
  'Continue editing': '繼續編輯',
  'Cancel changes': '取消變更',
  "Your edits aren't saved": '尚未儲存變更',
  'If you leave, any unsaved changes will be lost. Please save before leaving.':
    '如果選擇離開，編輯內容將不會保留，建議儲存後再離開。',
  Leave: '離開',
  'Once you sign in, the Merchant API will be automatically connected to SHOPLINE with no manual setup needed. Your product data will be automatically uploaded to Google Merchant Center, allowing them to be accessible in Google Ads, YouTube Live Shopping, and other Google features.':
    '登入後，Merchant API 即可自動串接至 SHOPLINE，無需手動設定。商品資料將即時更新至 Google Merchant Center，並可用於 Google 廣告、YouTube Live Shopping 及其他 Google 服務。',
  'Once you sign in, We will help you create and connect the Merchant Center account.':
    '登入後，我們將自動為您建立並串接 Merchant Center 帳號。',
  'Your store is currently connected to Google Merchant Center (GMC). Signing in will disconnect the existing GMC account and automatically create and connect a new one.':
    '商店目前已有串接的 Google Merchant Center (GMC)，登入後，將解除綁定現有的 GMC 帳號，並自動建立及串接新的 GMC 帳號。',
  'Ad Placement Area and Language': '廣告投放地區及語系',
  'The system will upload your products (including preorder and hidden products) to Google Merchant Center. Product ads will be displayed based on the selected placement area and language.':
    '系統將您的商品（包含預購、隱藏商品）上傳至 Google Merchant Center 後，會根據您設定的投放地區及語系展示商品廣告。',
  'Please enter the product name, summary, and description for the selected placement language to ensure successful product uploads.':
    '請注意，商品需填寫符合投放語系的標題、摘要及描述方可成功上傳。',
  Region: '投放地區',
  Locale: '投放語系',
  'Add a language to the list below': '新增語系至下方列表',
  'EmptyLocale - title': '還沒有數據',
  'EmptyLocale - subtitle': '從上面的設置中添加語言',
  'Please contact the Online Merchant Success Team to enable this feature for your store.':
    '請聯繫線上顧問，為您的商店開啟此功能權限',
  'To reconnect to Google Merchant Center, a new GMC account will be created following the new process to comply with Google\'s latest API standards. Please contact the Online Merchant Success Team to enable the "Automatically create and connect Merchant API" feature.':
    '若需重新串接 Google Merchant Center，將依新流程建立全新的 GMC 帳號，以符合 Google 最新 API 規範。請聯繫線上顧問啟用「自動建立與串接 Merchant API」功能。',
  'Sign in and authorize now to upgrade from Content API to Merchant API':
    '立即登入授權，將 Content API 升級為 Merchant API',
  'Due to Google policy changes, the Content API will be deprecated on 18 August 2026, and replaced by the Merchant API.':
    '因應 Google 政策，Content API 將於 2026/08/18 下架，並由 Merchant API 取代。',
  'Please complete the API upgrade as soon as possible to prevent any disruption to product uploads and ad delivery.':
    '請儘速完成 API 升級，避免影響您的商品上傳與廣告投放。',
  'Once authorized, you can upgrade to the Merchant API instantly with no manual setup required.':
    '登入授權後即可一鍵升級至 Merchant API，無需手動設定。',
  "We recommend that the store owner perform the authorization to avoid disruptions caused by changes to a staff member's account status or permissions.":
    '建議由店長進行授權，避免授權人員的 GMC 帳號遭停用或權限變更，影響商品上傳及廣告投放。',
  "If the authorized staff member's GMC account is suspended or permissions change, product uploads and ad delivery will be affected. If any changes occur, please contact the Online Merchant Success Team.":
    '若授權人員的 GMC 帳號停用或權限變更，將影響商品上傳及廣告投放。如有任何異動，請聯繫線上顧問。',
  'Google discontinued the Content API on 18 August 2026. Please upgrade to the Merchant API to keep syncing product data with your GMC account.':
    'Google 已於 2026/08/18 停止 Content API 服務，如需持續更新商品資料到 GMC 帳號，請升級到 Merchant API。',
  'Successfully upgraded to Merchant API': '成功升級為 Merchant API',
  'Content API has been upgraded to Merchant API. Your previous settings have been automatically applied. No reconfiguration is needed.':
    'Content API 已升級為 Merchant API，原有設定已為您自動沿用，無需重新設定。',
  'Upgrade Content API to Merchant API': '將 Content API 升級為 Merchant API',
  'If you need to disconnect Google Merchant Center, please contact the Online Merchant Success Team for assistance.':
    '若需解除串接 Google Merchant Center，請聯繫線上顧問。',
  'Disconnect Google Merchant Center?': '解除串接 Google Merchant Center？',
  'Product data syncing will stop, and ads linked to this account will be interrupted.':
    '商品資料將停止同步，與此帳號連結的廣告投放將會中斷。',
  'Your current Google account does not have administrative access to this GMC account. Please contact the store owner for authorization.':
    '您目前的 google 帳號沒有該 GMC 的管理權限，請聯繫店長進行授權。',
  'Insufficient permissions. Please log in to Google again and grant the required access.':
    '權限不足，請重新登入 Google 並完成相關授權',
  DATA_TABLE: {
    REGION: '地區',
    LOCALE: '語系',
    ACTION: '開啟/關閉',
  },
  LOCALE: {
    'zh-hant': '中文 - 台灣',
    'zh-tw': '中文 - 台灣',
    'zh-hk': '中文 - 香港特別行政區',
    'zh-cn': '中文 - 中國',
    en: '英文',
    ms: '馬來文',
    th: '泰文',
    vi: '越南文',
    id: '印尼文',
    de: '德文',
    fr: '法文',
    ja: '日文',
  },
  REGION: {
    TW: '台灣',
    CN: '中國',
    HK: '香港',
    JP: '日本',
    SG: '新加坡',
    MY: '馬來西亞',
    TH: '泰國',
    VN: '越南',
    PH: '菲律賓',
    US: '美國',
    AU: '澳洲',
    GB: '英國',
  },
  UNIT: {
    days: '天',
  },
};

export default main;
